import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  openNewPage,
  getHostName,
  API_GET_CART_PRODUCTS,
  API_UPDATE_CART_PRODUCTS,
} from "../modals/Constants";
import { getStorage, setStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import HeaderView from "../other-components/HeaderView/view";
import Button from "../UI/Button/ui";

function Cart() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deleteID, setDeleteID] = useState("");

  const [values, setValues] = useState({
    totalRecords: 0,
    totalAmount: 0,
    totalDiscount: 0,
    totalDeliveryFee: 0,
    subTotal: 0,
    cartThreshold: 0,

    currentPage: 1,
    totalPages: 0,
    pagination: false,
    dataLoaded: false,

    productList: [],
  });

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [suggestionAlert, setSuggestionAlert] = useState(false);

  const continueToDelete = (id) => {
    setDeleteID(id)
    setDeleteAlert(true)
  }

  const updateUIItems = (data) => {
    let tempData = [];

    for (let i = 0; i < data.length; i++) {
      let cartID = data[i]["item_cart_id"];
      let itemQuantity = data[i]["item_quantity"];

      tempData.push(
        <div className={screen.cartItem} key={cartID}>
          <img
            className="w-100-p br-5"
            src={data[i]["item_media"]}
            onClick={() => data[i]['item_type'] == 0 && (openNewPage(getHostName() + "/p/" + data[i]["item_slug"]))}
          />

          <div className={screen.cartContentsView}>
            <h6
              className={screen.title}
            >
              {data[i]["item_name"]}
            </h6>

            <p className={screen.sizeView}>Size: {data[i]["item_size"]}</p>

            <h6 className={screen.pricingView}>
              ₹{data[i]["item_final_price"]}
              {Number(data[i]["item_offer"]) !== 0 && (
                <s>₹{data[i]["item_price"]}</s>
              )}
            </h6>

            <div className={screen.controlView}>
              <div className={general.quantityView}>
                {data[i]['item_type'] == 0 && (
                  <button onClick={() => itemQuantity > 1 ? updateProduct(cartID, false) : null}>
                    <span className="material-symbols-outlined">
                      remove
                    </span>
                  </button>
                )}

                <p>{data[i]["item_quantity"]}{data[i]['item_type'] == 1 && (Number(data[i]["item_quantity"])==1 ? ' item' : ' items')}</p>

                {data[i]['item_type'] == 0 && (
                  <button onClick={() => itemQuantity < 100 ? updateProduct(cartID, true) : null}>
                    <span className="material-symbols-outlined">
                      add
                    </span>
                  </button>
                )}
              </div>

              <button className={screen.deleteBtn} onClick={() => continueToDelete(cartID)}>
                <span className="material-symbols-outlined">
                  delete
                </span>
              </button>
            </div>
          </div>
        </div >
      );
    }

    setValues((previousState) => {
      return { ...previousState, productList: tempData };
    });
  };

  function loadRecords() {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if ((data.status_code = "success")) {
          setStorage("app_cart_items", data.total_records);

          setValues((previousState) => {
            return {
              ...previousState,
              currentPage: data.current_page,
              totalPages: data.total_pages,
              totalRecords: data.total_records,
              totalAmount: data.total_amount,
              totalDiscount: data.total_discount,
              totalDeliveryFee: data.total_delivery_fee,
              subTotal: data.total_subtotal,
              cartThreshold: data.cart_threshold,
              dataLoaded: true,
            };
          });

          updateUIItems(data.data);
        }
      } catch (error) {
        setLoading(false);
      }
    }

    setLoading(true);
    const formData = {
      ACCOUNT_ID: getStorage("accountID"),
      ACCOUNT_ID: getStorage("accountID"),
      PAGE: 1,
    };
    requestAPI(API_GET_CART_PRODUCTS, formData);
  }

  const updateProduct = (cartID, addQuantity = false, isRemove = false) => {
    if (isRemove) {
      setDeleteAlert(false)
    }

    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          loadRecords();
        }
      } catch (error) {
        setLoading(false);
      }
    }

    if (cartID) {
      setLoading(true);

      const formData = {
        ACCOUNT_ID: getStorage("accountID"),
        CART_ID: cartID,
        CART_ADD_QUANTITY: addQuantity,
        CART_DELETE: isRemove,
      };
      requestAPI(API_UPDATE_CART_PRODUCTS, formData);
    }
  };

  const proceedCheckout = () => {
    if (values.subTotal >= values.cartThreshold) {
      navigate("/checkout", { replace: false });
    } else {
      setSuggestionAlert(true)
    }
  };

  const paginate = (command) => {
    let newPage = 0;
    if (command == "plus") {
      if (values.currentPage < 100 && values.pagination) {
        newPage = values.currentPage + 1;
      }
    } else {
      if (values.currentPage > 1) {
        newPage = values.currentPage - 1;
      }
    }

    if (newPage > 0) {
      setValues((previousState) => {
        return {
          ...previousState,
          currentPage: newPage,
        };
      });
    }
  }

  useEffect(() => {
    loadRecords();
  }, []);

  return (
    <div className={[general.appView]}>
      <LoadingDialog isOpen={loading} />

      <AlertDialog
        isOpen={deleteAlert}
        title={"Alert!"}
        description="Are you sure you want to remove this?"
        onClose={() => setDeleteAlert(false)}
        actions={[
          { label: "No", variant: "neutral", onClick: () => setDeleteAlert(false) },
          { label: "Yes, Remove", variant: "positive", onClick: () => updateProduct(deleteID, false, true) }
        ]}
      />

      <AlertDialog
        isOpen={suggestionAlert}
        title={"Alert!"}
        description={`Your cart total is ₹${values.subTotal}. A minimum order of ₹${values.cartThreshold} is required to checkout.`}
        onClose={() => setSuggestionAlert(false)}
        actions={[
          { label: "Ok", variant: "neutral", onClick: () => setSuggestionAlert(false) }
        ]}
      />

      <div className={[general.appChildView]}>
        <HeaderView screen={"mybag"} />

        <div className={general.appLocationViews}>
          <p>My Bag ({values.totalRecords} item)</p>
        </div>

        <div className={[general.appContentsView]}>
          {values.totalRecords > 0 ?
            <div className={[screen.cartView, general.mgB100px].join(" ")}>

              <div className={[screen.contentsView]}>
                {/* <div className={[product.offerView]}>
                    <img
                      alt="icon"
                      src={require("../media/icons/icon_delivery_car.png")}
                    />
                    <span className={general.mgL10px}>
                      {values.totalDeliveryFee > 0
                        ? "Shop For 100rs more to get FREE Delivery"
                        : "Yay! You get FREE delivery on this order"}
                    </span>
                  </div> */}

                {values.productList}

                <div className={[general.viewCenter, general.pd10px, general.mgT25px].join(" ")}>
                  <div className={general.paginationView}>
                    <button className={values.currentPage === 1 ? general.disable : null} onClick={() => paginate("minus")}><span className="material-symbols-outlined icon-size-xs">arrow_back_ios_new</span></button>
                    <p>{values.currentPage}/{values.totalPages}</p>
                    <button className={!values.pagination ? general.disable : null} onClick={() => paginate("plus")}><span className="material-symbols-outlined icon-size-xs">arrow_forward_ios</span></button>
                  </div>
                </div>
              </div>

              <div className={screen.overview}>
                <section>
                  <p className={screen.title}>Cart totals</p>

                  <br></br>
                  <div className={screen.listView}>
                    <p>Total MRP (Inc. of taxes)</p>
                    <p>₹{values.totalAmount}</p>
                  </div>

                  <div className={screen.listView}>
                    <p>Delivery Fee</p>
                    <p>{values.totalDeliveryFee > 0
                      ? "₹" + values.totalDeliveryFee
                      : "Free"}</p>
                  </div>

                  <div className={screen.listView}>
                    <p>Bag Discount</p>
                    <p>-₹{values.totalDiscount}</p>
                  </div>

                  <br></br>
                  <div className={screen.listView}>
                    <p>Sub Total</p>
                    <p className={screen.subTitle}>₹{values.subTotal}</p>
                  </div>
                </section>

                <br></br>
                <Button
                  text="Proceed"
                  rounded={true}
                  fullWidth={true}
                  action={{ onClick: () => proceedCheckout() }} />
              </div>
            </div>
            : values.totalRecords <= 0 && values.dataLoaded &&
            (<div
              className={screen.emptyContentsView}
            >
              <img src={require("../media/icons/shopping_bag_icon.png")} />
              <p>Nothing in tha bag</p>

              <br></br>
              <Button
                text="Continue Shopping"
                appearance={3}
                rounded={true}
                action={{ onClick: () => navigate("/", { replace: false }) }}
              />
            </div>)}
        </div>
      </div>
    </div>
  );
}

export default Cart;
